import { Provider } from "react-redux";
import store from "./state/store";
import PageHeader from "./Components/PageHeader/PageHeader";
import ContentArea from "./Components/ContentArea/ContentArea";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/customTheme";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Box } from "@mui/system";

function App() {
  return (
    <>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
              }}
            >
              <PageHeader title="SD36 Staff Workshop Registration" />
              <Routes>
                <Route path="/" element={<ContentArea />} />
                <Route path="/:id" element={<ContentArea />} />
              </Routes>
            </Box>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default App;
